var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-24 md-text-48",class:{'pt-15 md-pt-20': _vm.sliceNo == 0},style:(_vm.gapStyle(_vm.slice.primary.gap))})}
var staticRenderFns = []

export { render, staticRenderFns }